<template>
  <p-product-detail-block data-test="CropsWithVegetativeStage" class="no-padding">
    <div>
      <table class="vegetative-stage-by-crops">
        <thead>
          <tr>
            <th>{{ i18n._('Culture') }}</th>
            <th>{{ i18n._(`Stades d'application`) }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="vegetative-stage-by-crops__detail"
            v-for="cropsByVegetativeStage in vegetativeStageByCrops"
            :key="cropsByVegetativeStage.culture"
          >
            <td class="vegetative-stage-by-crops__detail-crops" data-test="crops">
              {{ cropsByVegetativeStage.culture }}
            </td>
            <td data-test="vegetative-stage">{{ cropsByVegetativeStage.vegetative_stage }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </p-product-detail-block>
</template>

<script lang="ts">
import { type PropType, defineComponent } from 'vue'
import { i18n } from '@b2ag/locale'
import type { VegetativeStageByCrops } from './typings'
import PProductDetailBlock from '../PProductDetailBlock/PProductDetailBlock.vue'

export default defineComponent({
  name: 'PProductDetailBlockCrops',
  props: {
    vegetativeStageByCrops: {
      type: Array as PropType<VegetativeStageByCrops[]>,
      default: () => [],
    },
  },
  components: {
    PProductDetailBlock,
  },
  setup() {
    return {
      i18n,
    }
  },
})
</script>

<style scoped lang="scss">
.vegetative-stage-by-crops {
  width: 100%;

  tr {
    border-bottom: 1px solid var(--color-inactive-light);
  }

  th {
    background-color: var(--color-text-light);
    color: var(--color-white);
    text-transform: uppercase;
  }

  th,
  td {
    padding: 10px 20px;
  }

  &__detail-crops {
    font-weight: bold;
  }
}
</style>
